import { BrandTabType } from './types';

// TODO replace with commented brandTabs after feature will be unfrosted
// export const brandTabs: BrandTabType[] = ['edit', 'point list', 'product list', 'catalogue list'];
export const brandTabs: BrandTabType[] = ['edit', 'point list', 'product list'];

export const tabsToUrl: Record<BrandTabType, string> = {
  edit: '',
  'point list': '/points',
  'product list': '/products',
  // TODO uncommented after feature will be unfrosted
  // 'catalogue list': '/catalogues',
};
